import {combineReducers} from 'redux';

import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {activeUpsell} from './reducers/activeUpsell/activeUpsell';
import {drawerPopup} from './reducers/drawerPopup/drawerPopup';
import {oneTimeCoupon} from './reducers/oneTimeCoupon/oneTimeCoupon';
import {order} from './reducers/order/order';
import {orderItems} from './reducers/orderItems/orderItems';
import {orderLast} from './reducers/orderLast/orderLast';
import {orderStatus} from './reducers/orderStatus/orderStatus';
import {upsellsReducer as upsells} from './reducers/upsells/upsells';
import {upsellTimer} from './reducers/upsellTimer/upsellTimer';

const reducers = {
    activeUpsell,
    drawerPopup,
    oneTimeCoupon: persistReducer({key: 'oneTimeCoupon', storage}, oneTimeCoupon),
    order,
    orderItems,
    orderLast,
    orderStatus,
    upsells,
    upsellTimer,
};

export const rootReducer = combineReducers(reducers);
